
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 4 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 16c-.55 0-1.02-.196-1.413-.588A1.926 1.926 0 010 14c0-.55.196-1.02.588-1.412A1.926 1.926 0 012 12c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412 0 .55-.196 1.02-.587 1.412A1.926 1.926 0 012 16zm0-6c-.55 0-1.02-.196-1.413-.588A1.926 1.926 0 010 8c0-.55.196-1.02.588-1.412A1.926 1.926 0 012 6c.55 0 1.02.196 1.413.588C3.804 6.979 4 7.45 4 8c0 .55-.196 1.02-.587 1.412A1.926 1.926 0 012 10zm0-6C1.45 4 .98 3.804.587 3.413A1.926 1.926 0 010 2C0 1.45.196.98.588.587A1.926 1.926 0 012 0c.55 0 1.02.196 1.413.588C3.804.979 4 1.45 4 2c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 012 4z"}})])
          )
        }
      }
    